<template>
    <div>
        <v-btn-toggle class="no-box-shadow no-background" v-if="deveMostrarMenuInteiro" active-class="no-box-shadow no-background">

        <v-tooltip top v-if="statusEdocs" :open-delay="150" :close-delay="0">
          <template v-slot:activator="{ on }">
            <v-icon
                  v-on="on"
                  :style="{color: statusEdocs.cor}"
                  :aria-label="statusEdocs.texto"
                  size="20px"
            >{{ statusEdocs.nome }}</v-icon>
          </template>
          <span>{{ statusEdocs.texto }}</span>
        </v-tooltip>

        <v-menu v-if="!deveOcultarBotaoDownload" bottom left offset-x transition="slide-x-transition" close-on-click close-on-content-click>
            <template v-slot:activator="{ on }">
                <v-btn title="Baixar Documento"  v-on="on" class="button-icon-button-group no-background"
                       :key="'botaoBaixar' + documento.id" flat depressed active-class="no-background">
                    <v-icon size="16px">mdi mdi-file-download-outline</v-icon>
                </v-btn>
            </template>

            <v-list class="lista-menu">
                <v-list-tile
                    v-for="(item, index) in opcoesDownloadAtivas"
                    :key="index"
                    :value="item"
                    @click.stop="$emit('baixarDocumentos', item.valor)">

                    {{ item.label }}
                </v-list-tile>
            </v-list>
        </v-menu>

        <v-btn v-for="menu in menuNaoJuntados" :title="getMenuTitle(menu)"
               :key="menu.key + documento.id"
               @click.stop="processarClickMenu(menu)" flat
               class="button-icon-button-group"
               active-class="no-background" depressed>
            <v-icon :class="{
                    juntado: documento.juntado && menu.nome === 'Juntar',
                   assinado: documento.assinado && menu.nome === 'Assinar',
                    'operacao-nao-permitido': !devePermitirAssinar && menu.nome === 'Assinar',
                }" size="16px">{{ getIconeMenu(menu) }}</v-icon>
        </v-btn>

        <!-- Menu específico para Termo de Desentranhamento -->
        <template v-if="isTermoDesentranhamentoDoc">
            <!-- Botão Redigir para Termo de Desentranhamento -->
            <v-btn v-if="deveExibirRedigirTermoDesentranhamento"
                   title="Redigir documento"
                   @click.stop="$emit('redigirDocumentos')"
                   flat class="button-icon-button-group"
                   active-class="no-background" depressed
                   :key="'botaoRedigir' + documento.id">
                <v-icon size="16px">mdi mdi-pencil</v-icon>
            </v-btn>

            <!-- Botão Concluir Edição para Termo de Desentranhamento -->
            <v-btn v-if="deveExibirConcluirEdicaoTermoDesentranhamento"
                   title="Concluir edição do documento"
                   @click.stop="abrirModalConfirmacaoConcluirEdicao"
                   flat class="button-icon-button-group"
                   active-class="no-background" depressed
                   :key="'botaoConcluirEdicao' + documento.id">
                <v-icon size="16px">mdi mdi-check-circle</v-icon>
            </v-btn>
        </template>

        <!-- Ícone informativo para termo de desentranhamento em elaboração -->
        <v-btn v-else-if="deveExibirIconeInformativoTermo"
               title="Existe um termo de desentranhamento em Elaboração para este documento. Clique na ação para acessar a etapa de elaboração"
               @click.stop="acessarTermoDesentranhamento"
               flat class="button-icon-button-group"
               active-class="no-background" depressed
               :key="'botaoInformacaoTermo' + documento.id">
            <v-icon size="16px">mdi mdi-information</v-icon>
        </v-btn>

        <!-- Menu padrão para outros documentos -->
        <v-tooltip v-else-if="documento.juntado && !deveOcultarMenuTresPontos" top :disabled="menusDocsJuntadosFiltrados.length > 0" :open-delay="150" :close-delay="0">
            <template v-slot:activator="{ on }">
                <v-menu bottom left offset-x
                        transition="slide-x-transition"
                        :disabled="menusDocsJuntadosFiltrados.length === 0">
                    <template v-slot:activator="{ on: onMenu }">
                        <v-btn v-on="{...on, ...onMenu}" flat title="Mais opções" class="button-icon-button-group"
                               active-class="no-background" depressed
                               :disabled="menusDocsJuntadosFiltrados.length === 0"
                               :key="'botaoMaisOpcoes' + documento.id">
                            <v-icon size="16px">mdi mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list class="overflow-y-hidden overflow-x-hidden">
                        <v-list-tile v-for="menu in menusDocsJuntadosFiltrados" :key="menu.key + documento.id"
                                     @click.stop="$emit(menu.evento)" >
                            <v-list-tile-avatar>
                                <span :class="menu.icon + ' icone-link-de-botoes-acoes'"></span>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <a class="grey--text link-de-botoes-acoes" :title="menu.title">{{ menu.nome }}</a>
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </template>
            <span>Documento já enviado ao E-docs</span>
        </v-tooltip>
    </v-btn-toggle>

    <v-btn-toggle class="no-box-shadow no-background" v-else active-class="no-box-shadow no-background">
        <v-menu v-if="!deveOcultarBotaoDownload" bottom left offset-x transition="slide-x-transition" close-on-click close-on-content-click>
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" title="Baixar Documento" class="button-icon-button-group no-background"
                       :key="'botaoBaixar' + documento.id" flat depressed active-class="no-background">
                    <v-icon size="16px">mdi mdi-file-download-outline</v-icon>
                </v-btn>
            </template>

            <v-list class="lista-menu">
                <v-list-tile
                    v-for="(item, index) in opcoesDownloadAtivas"
                    :key="index"
                    :value="item"
                    @click.stop="$emit('baixarDocumentos', item.valor)">

                    {{ item.label }}
                </v-list-tile>
            </v-list>
        </v-menu>
    </v-btn-toggle>

    <!-- Modal de confirmação para concluir edição -->
    <ModalConfirmacaoTermoDesentranhamento
        :exibir="exibirModalConfirmacao"
        :processando="processandoSincronizacao"
        @cancelar="fecharModalConfirmacao"
        @confirmar="confirmarConcluirEdicao"
    />
    </div>
</template>

<script>
import { opcoesDownload, actionTypes } from '@/core/constants'
import { mapState } from 'vuex'
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import alertMixin from '@/views/mixins/alert'
import ModalConfirmacaoTermoDesentranhamento from './ModalConfirmacaoTermoDesentranhamento.vue'

const MENU_VIRTUALIZAR = {
    nome: 'Virtualizar',
    title: 'Virtualizar documento',
    icon: 'mdi mdi-file-cloud-outline',
    key: 'botaoVirtualizar',
    evento: 'virtualizarDocumentos'
}
export default {
    name: 'BotoesAcoes',
    components: {
        ModalConfirmacaoTermoDesentranhamento
    },
    mixins: [alertMixin],
    props: ['documento'],
    data() {
        return {
            exibirModalConfirmacao: false,
            processandoSincronizacao: false,
            menusDocsJuntados: [
                {
                    nome: 'Desentranhar',
                    title: 'Desentranhar documento',
                    icon: 'mdi mdi-close',
                    key: 'botaoDesentranhar',
                    evento: 'desentranharDocumentos'
                },
                {
                    nome: 'Redigir',
                    title: 'Redigir documento',
                    icon: 'mdi mdi-pencil',
                    key: 'botaoRedigir',
                    evento: 'redigirDocumentos'
                },
                {
                    nome: 'Repaginar',
                    title: 'Repaginar documento',
                    icon: 'mdi mdi-format-list-numbered',
                    key: 'botaoRepaginar',
                    evento: 'reordenarDocumentos'
                },
                {
                    nome: 'Cancelar',
                    title: 'Cancelar documento',
                    icon: 'mdi mdi-close-circle-outline',
                    key: 'botaoCancelar',
                    evento: 'cancelarDocumentos'
                },
            ],
            menusDocumentosNaoJuntados: [
                {
                    nome: 'Assinar',
                    title: 'Assinar documento',
                    icon: 'mdi mdi-file-sign',
                    key: 'botaoAssinar',
                    evento: 'assinarDocumentos'
                },
                {
                    nome: 'Juntar',
                    title: 'Juntar documento',
                    icon: 'mdi mdi-file-replace-outline',
                    key: 'botaoJuntar',
                    evento: 'juntarDocumentos'
                },
            ]
        }
    },
    computed: {
        ...mapState(['loki', 'parametros']),
        devePermitirAssinar() {
            return !this.documento.fornecedorId  && !this.documento.assinado && !this.documento.juntado && this.documento.documentoVirtualizadoId
        },
        virtualizacaoAtiva() {
            return this.parametros &&
                   this.parametros.propriedadesCompraDiretas &&
                   this.parametros.propriedadesCompraDiretas.integration &&
                   this.parametros.propriedadesCompraDiretas.integration.virtualizacao &&
                   this.parametros.propriedadesCompraDiretas.integration.virtualizacao.ativo || false
        },
        menuNaoJuntados() {
            if (this.documento.documentoVirtualizadoId) {
                return this.menusDocumentosNaoJuntados
            }

            if (this.isTermoDesentranhamentoDoc) {
                return []
            }

            return this.virtualizacaoAtiva ? [MENU_VIRTUALIZAR] : []
        },
        menusDocsJuntadosFiltrados() {
            let menusFiltrados = this.menusDocsJuntados

            if (!this.documento.documentoVirtualizadoId) {
                menusFiltrados = menusFiltrados.filter(menu => menu.nome !== 'Cancelar')
            }

            const tipoDoc = (this.documento.tipo || '').toLowerCase()
            const descricaoTipoDoc = (this.documento.descricaoTipo || '').toLowerCase()
            const situacaoDoc = (this.documento.situacao || '').toLowerCase()

            const isTermoDesentranhamento = tipoDoc.includes('termo') && tipoDoc.includes('desentranhamento') ||
                descricaoTipoDoc.includes('termo') && descricaoTipoDoc.includes('desentranhamento')

            const isSituacaoGerado = situacaoDoc.includes('gerado') || situacaoDoc.includes('rascunho')

            if (!isTermoDesentranhamento || !isSituacaoGerado) {
                menusFiltrados = menusFiltrados.filter(menu => menu.nome !== 'Redigir')
            }

            if (this.documento.situacaoEdocs === 'AGUARDANDO' || this.documento.situacaoEdocs === 'SINCRONIZADO') {
                menusFiltrados = menusFiltrados.filter(menu =>
                    menu.nome !== 'Desentranhar' &&
                    menu.nome !== 'Cancelar' &&
                    menu.nome !== 'Repaginar'
                )
            }

            if (this.documento.possuiTermoDesentranhamento) {
                menusFiltrados = menusFiltrados.filter(menu => !['Desentranhar', 'Repaginar', 'Cancelar'].includes(menu.nome))
            }

            return menusFiltrados
        },
        opcoesDownloadAtivas(){
            if(!this.documento.assinado)
                return opcoesDownload.tiposDownload.filter(tipo => tipo.valor !== 'ASSINADO')
            else
                return opcoesDownload.tiposDownload
        },
        deveMostrarMenuInteiro(){
            return azAuth(this.loki.user.authorities, ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior'])
        },
        statusEdocs() {
            if (this.parametros.propriedadesCompraDiretas.identidadeCliente === 'ES' &&
                this.parametros.propriedadesCompraDiretas.integration.edocs.ativo === true &&
                this.documento.situacaoEdocs !== null) {

                if (this.documento.situacaoEdocs === 'AGUARDANDO') {
                    return {
                        cor: 'orange',
                        nome: 'error',
                        texto: 'Aguardando processamento para envio ao E-docs'
                    }
                }

                if (this.documento.situacaoEdocs === 'SINCRONIZADO') {
                    return {
                        cor: 'green',
                        nome: 'check_circle',
                        texto: 'Enviado ao E-docs'
                    }
                }
            }
            return null
        },
        isTermoDesentranhamentoDoc() {
            const tipoDoc = (this.documento.tipo || '').toLowerCase()
            const descricaoTipoDoc = (this.documento.descricaoTipo || '').toLowerCase()

            return tipoDoc.includes('termo') && tipoDoc.includes('desentranhamento') ||
                   descricaoTipoDoc.includes('termo') && descricaoTipoDoc.includes('desentranhamento')
        },
        deveExibirRedigirTermoDesentranhamento() {
            if (!this.isTermoDesentranhamentoDoc) return false

            const situacaoDoc = (this.documento.situacao || '').toLowerCase()
            const isSituacaoGerado = situacaoDoc.includes('gerado') || situacaoDoc.includes('rascunho')

            return isSituacaoGerado && !this.documento.juntado
        },
        deveExibirConcluirEdicaoTermoDesentranhamento() {
            if (!this.isTermoDesentranhamentoDoc) return false

            const situacaoDoc = (this.documento.situacao || '').toLowerCase()
            const isSituacaoGerado = situacaoDoc.includes('gerado') || situacaoDoc.includes('rascunho')

            return isSituacaoGerado && !this.documento.juntado
        },
        deveExibirIconeInformativoTermo() {
            return this.documento.possuiTermoDesentranhamento &&
                   this.documento.situacaoTermoDesentranhamento === 'Gerado' &&
                   this.documento.idTermoDesentranhamento
        },
        deveOcultarMenuTresPontos() {
            return this.documento.possuiTermoDesentranhamento &&
                   this.documento.situacaoTermoDesentranhamento === 'Juntado'
        },
        deveOcultarBotaoDownload() {
            return this.isTermoDesentranhamentoDoc &&
                   this.documento.situacao &&
                   this.documento.situacao.toLowerCase().includes('gerado')
        }
    },
    methods: {
        processarClickMenu(menu) {
            switch (menu.nome) {
            case 'Assinar':
                if (this.devePermitirAssinar)
                    window.open(this.documento.url, '_blank')
                break
            case 'Juntar':
                if (!this.documento.juntado)
                    this.$emit(menu.evento)
                break
            default:
                this.$emit(menu.evento)
            }
        },
        getIconeMenu(menu) {
            switch (menu.nome) {
            case 'Assinar':
                return this.menuAssinarIcone(menu)
            case 'Juntar':
                return this.menuJuntarIcone(menu)
            default:
                return menu.icon
            }
        },
        menuAssinarIcone(menu) {
            if (this.documento.assinado)
                return 'mdi mdi-check-all'
            if (!this.devePermitirAssinar)
                return 'mdi mdi-close'
            return menu.icon
        },
        menuJuntarIcone(menu) {
            if (this.documento.juntado)
                return 'mdi mdi-check-all'
            return menu.icon
        },
        getMenuTitle(menu) {
            switch (menu.nome) {
            case 'Assinar':
                return this.menuAssinarTitle(menu)
            case 'Juntar':
                return this.menuJuntarTitle(menu)
            default:
                return menu.title
            }
        },
        menuAssinarTitle(menu){
            if (this.documento.assinado)
                return 'Documento assinado'
            if (!this.devePermitirAssinar)
                return 'Assinatura não permitida'
            return menu.title
        },
        menuJuntarTitle(menu){
            if (this.documento.juntado)
                return 'Documento juntado'
            return menu.title
        },
        abrirModalConfirmacaoConcluirEdicao() {
            this.exibirModalConfirmacao = true
        },
        fecharModalConfirmacao() {
            this.exibirModalConfirmacao = false
        },
        async confirmarConcluirEdicao() {
            try {
                this.processandoSincronizacao = true

                const response = await this.$store.dispatch(actionTypes.COMPRADOR.SINCRONIZAR_DOCUMENTO_EDITOR_TEXTO, {idDocumentoEditorTexto: this.documento.documentoId})

                this.mostrarNotificacaoSucesso(response.mensagem || 'Documento sincronizado com sucesso!')
                this.fecharModalConfirmacao()

                this.$emit('documentoSincronizado', {documento: this.documento, mensagem: response.mensagem || 'Documento sincronizado com sucesso!'})

            } catch (e) {
                this.mostrarNotificacaoErro(e.message)
            } finally {
                this.processandoSincronizacao = false
            }
        },
        acessarTermoDesentranhamento() {
            if (this.documento.idTermoDesentranhamento) {
                this.$router.push({
                    name: 'termoDesentranhamentoRedigir',
                    params: {
                        id: this.$route.params.id,
                        idTermo: this.documento.idTermoDesentranhamento
                    }
                })
            } else {
                this.mostrarNotificacaoErro('Termo de desentranhamento não encontrado')
            }
        }
    }
}
</script>

<style scoped>
.v-icon.assinado {
    color: var(--v-primary-base) !important;
    background-color: transparent !important;
    opacity: 1;
    z-index: 999;
}

.v-icon.juntado {
    color: var(--v-secondary-base) !important;
    background-color: transparent !important;
    opacity: 1 !important;
    z-index: 999 !important;
}

.v-icon.operacao-nao-permitido {
    color: #664d03 !important;
}

.button-icon-button-group {
    color: var(--v-color-ciza-escuro-3-base) !important;
    background-color: transparent !important;
}

.no-box-shadow {
    box-shadow: none !important;
}

.badge-content{
  color:#1565c0;
  display:inline-block;
  width:16px;
  text-align:center;
  cursor: default;
  user-select: none;
}

.no-background {
    background-color: transparent !important;
}
</style>
